import {useEffect, useState} from 'react'
import {UserModel} from '../../auth'
import { getBestSellerProductsInfo } from '../core/_requests'
import { IBestSellerProductsModel } from '../core/_models'
import BestSellerProductsCardRow from './BestSellerProductsCardRow'
import { useIntl } from 'react-intl'

type Props = {
  className: string
  language: string
  currentUser: UserModel | undefined
}

const BestSellerProductsCard: React.FC<Props> = ({language, currentUser, className}) => {
  const {formatMessage} = useIntl()
  const [state, setState] = useState<IBestSellerProductsModel[]>([])

  useEffect(() => {
    const getData = async () => {
      const {data} = await getBestSellerProductsInfo(currentUser?.token, language)
      if (data) {
        setState(data.data.best_seller_products)
      }
    }
    getData()
  }, [])

  return (
    <div className={className}>
      <div className='hsb-section-head'>
        <h3 className='hsb-section-title'>{formatMessage({ id: "best_seller_prods" })}</h3>
      </div>
      <div className='hsb-table-wrap'>
        <table className='hsb-table'>
          <thead>
            <tr>
              <th>{formatMessage({ id: "prod_name" })}</th>
              <th>{formatMessage({ id: "barcode" })}</th>
              <th className='hsb-td-end'>{formatMessage({ id: "sold_qty" })}</th>
            </tr>
          </thead>
          <tbody>
            {state && (
              state.map((item)=>(
                <BestSellerProductsCardRow key={item.product_id} item={item} />
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default BestSellerProductsCard
